import {
  CheckoutDataFragment,
  GiftcardApplyError,
} from "../../../../api/backend/backend-api"
import {
  checkoutGiftcardApply,
  checkoutGiftcardRemove,
} from "../../../../api/backend/checkout/api"
import { basketChange } from "./basketChange"

export const applyGiftcard = (
  giftcardCode: string,
  callback?: () => void,
  errorCallback?: (error: any) => void
) =>
  basketChange({
    operation: async (basket, languageId) => {
      const result = await checkoutGiftcardApply({
        giftcard: {
          code: giftcardCode,
        },
        id: basket.shopify.id,
        languageId,
      })
      if (result.data?.checkoutApplyGiftcard.error) {
        errorCallback?.(result.data?.checkoutApplyGiftcard.error)
        return undefined
      }
      return result.data?.checkoutApplyGiftcard.data as CheckoutDataFragment
    },
    callback,
    errorCallback: () => errorCallback?.(GiftcardApplyError.GenericError),
  })

export const removeGiftcard = (
  giftcardCode: string,
  callback?: () => void,
  errorCallback?: (error: any) => void
) =>
  basketChange({
    operation: async (basket, languageId) => {
      const result = await checkoutGiftcardRemove({
        giftcard: {
          code: giftcardCode,
        },
        id: basket.shopify.id,
        languageId,
      })
      return result.data?.checkoutRemoveGiftcard.data as CheckoutDataFragment
    },
    callback,
    errorCallback,
  })
